import { ScaleMode } from './../timeline';
import { Timeline, Milestone } from '../../components/Timeline';
import { Color, defaultColor } from '../colors';
import { buildLayout } from '../timeline';
import { subtractDays, addDays } from '../date';

const today = new Date();

const scaleMode: ScaleMode = '2-weeks';
const screaming = false;
const shouldCompact = false;
const highlightWeekends = true;
const firstDate = subtractDays(today, 15);
const totalDays = 60;

const abraDate = subtractDays(today, 2);
const babraDate = addDays(abraDate, 2);
const cadabraDate = addDays(babraDate, 2);
const bars = [
  {
    id: 'a',
    title: 'Abra',
    color: 'blackInk' as Color,
    done: false,
    startDate: abraDate,
    endDate: addDays(abraDate, 5),
    preferredY: 0,
  },
  {
    id: 'b',
    title: 'Babra',
    color: defaultColor as Color,
    done: false,
    startDate: babraDate,
    endDate: addDays(babraDate, 5),
    preferredY: 1,
  },
  {
    id: 'c',
    title: 'Cadabra',
    color: 'springGreen' as Color,
    done: false,
    startDate: cadabraDate,
    endDate: addDays(cadabraDate, 5),
    preferredY: 2,
  },
];

const milestoneDate = addDays(today, 3);
const milestones: Milestone[] = [
  {
    id: 'a',
    title: 'Launch Date',
    date: milestoneDate,
  },
];

const layout = buildLayout(bars, firstDate);

const timeline: Timeline = {
  id: 'basic',
  title: 'Basic',
  bars,
  layout,
  milestones,
  highlightWeekends,
  shouldCompact,
  firstDate,
  totalDays,
  screaming,
  scaleMode,
};

export default timeline;
